import { extendTheme } from '@chakra-ui/react';

import {
  BG_PRIMARY,
  BG_SECONDARY,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
  TEXT_ALTERNATIVE,
  BG_LAYER,
  BG_ALTERNATIVE,
} from '@/constants/colors';
import { FONT_FAMILY } from '@/constants/default-props';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://cha
 kra-ui.com/guides/using-fonts
 */
const theme = {
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  fonts: {
    heading: `'AstonScript', cursive;`,
    subHeading: `'Bodoni', serif;`,
    subHeading_lv2: `'Bodoni', serif;`,
    body: FONT_FAMILY.body,

    // for generator purpose
    jost: `'Jost', sans-serif;`,
    delafield: `'Mrs Saint Delafield', cursive;`,
  },
  fontSizes: {
    heading: '24px',
    subHeading: '18px',
    subHeading_lv2: '18px',
    body: '18px',
  },
  fontWeights: {
    heading: 400,
    subHeading: 400,
    subHeading_lv2: 800,
    body: 800,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-subHeading': '',
        '--fontItalic-subHeading_lv2': '',
        '--fontItalic-body': '',
      },
    },
  },
  colors: {
    bgPrimary: 'rgba(16,50,72,1)',
    bgSecondary: '#fff8ed',
    bgAlternative: 'rgba(16,50,72,1)',
    bgLayer: 'rgba(123,166,196,1)',
    mainColorText: '#ffffff',
    secondaryColorText: '#ffebca',
    alternativeColorText: 'rgba(16,50,72,1)',

    transparent: 'transparent',
  },
  // override components
  components: {
    Heading: {
      baseStyle: {
        letterSpacing: 'normal',
      },
    },
  },
};

export default extendTheme(theme);
